<template>
  <p class="text-muted m-0 pt-1 pl-3 text-left text-sm-right">
    <small>
      Made by
      <a href="https://twitter.com/AngelInfanti" target="_blank"
        >Angel Infanti</a
      >
    </small>
  </p>
</template>

<script>
export default {
  name: "MadeByFoot",
};
</script>
